export let checkMailCampaignUser = () => {
  let landingEmail = sessionStorage.getItem("landingEmail");
  let mailCampaignUserCheck = landingEmail ? true : false;
  return mailCampaignUserCheck;
};
